import { gql } from "@apollo/client";

export const CREATE_RESPONSE = gql`
  mutation CreateResponse($input: createResponseInput) {
    createResponse(input: $input) {
      employeeId
    }
  }
`;

export const GET_RESPONSE = gql`
  query GetResponse($employeeId: String, $responseColumn: String) {
    getResponse(employeeId: $employeeId, responseColumn: $responseColumn) {
      employeeId
      employeeResponse
      id
      actionType
      l1ManagerResponse
      l2ManagerResponse
      templateId
      l1ManagerId
      l2ManagerId
      l1ManagerResponseForManager
      l2ManagerResponseForManager
      l1ManagerIdForManager
      l2ManagerIdForManager
      assignedPerformanceId
      employeeDetails {
        firstName
        lastName
      }
    }
  }
`;

export const UPDATE_RESPONSE = gql`
  mutation UpdateResponse($input: updatePerformanceInput) {
    updateResponse(input: $input)
  }
`;
